import React, { useEffect } from 'react';
import { getTreatmentByRefDoctorId } from 'app/api-ws/treatment-ws';
import { updateTreatmnet } from 'app/api-ws/treatment-ws';
import { useState } from 'react';
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Snackbar,
  Typography
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import useAuth from 'app/hooks/useAuth';

function OldPatient({ handleDialogClose }) {
  const {user} = useAuth(); 
  const [appointments, setAppointments] = useState([]);
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');

  useEffect(() => {
    fetchAppointmentDetails();
  }, []);

  const fetchAppointmentDetails = () => {
    getTreatmentByRefDoctorId('65f1496c72b90e7a38cc6055', user?.authToken)
      .then((res) => {
        setAppointments(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateTreatmentSubmit = (appointment) => {
    const treatmentRequest = {
      _id: appointment._id,
      appointment: {
        appointmentStatus: 'Approved'
      }
    };
    // console.log('treatmentRequest', treatmentRequest);
    updateTreatmnet(treatmentRequest)
      .then((res) => {
        console.log(res);
        if (res.data.status === 'success') {
          setSnackBarMessage('Appointment updated Successfully');
          setSnackBarType('success');
          showSnackBar();
          setExpandedAccordion(null);
          handleDialogClose();
        } else {
          setSnackBarMessage('Error in updating Appointment');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in updating Treatment');
        setSnackBarType('error');
        showSnackBar();
      });
    console.log('submitted');
  };

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  const today = new Date().toISOString().split('T')[0];

  const todayAppointments = appointments.filter((appointment) => {
    // console.log("dsjcdjkcbjkscbhsbcjhdcbjhsbc", appointment)
    return (
      appointment.appointment &&
      appointment.appointment.nextVisitDate &&
      appointment.appointment.nextVisitDate.split('T')[0] === today
    );
  });

   console.log('Appointments for today:', todayAppointments);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <h2>Appointments for Today:</h2>

      {todayAppointments.map((appointment, index) => (
        <Accordion
          expanded={expandedAccordion === `panel${index}`}
          onChange={handleAccordionChange(`panel${index}`)}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Typography>{appointment?.refPatientId?.patientName}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>Are You Arrived at Destination</Typography>
          </AccordionDetails>
          <AccordionActions>
            <Button onClick={() => setExpandedAccordion(null)}>Cancel</Button>
            <Button onClick={() => updateTreatmentSubmit(appointment)}>Agree</Button>
          </AccordionActions>
        </Accordion>
      ))}
    </div>
  );
}

export default OldPatient;
